import React, { useEffect, useState } from "react";
import { Card, Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import { getClientByCode } from "../services/clientService";
import { toast } from "react-toastify";
import { useSelectedItemStore } from "../store/useSelectedItemStore";

interface ClientCardProps {
  processNumber: string;
  refNumber: string;
}

const ClientCard: React.FC<ClientCardProps> = ({
  processNumber,
  refNumber,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [clientInfo, setClientInfo] = useState<any>();

  const getClientInfo = async () => {
    try {
      const data = await getClientByCode(refNumber);
      setClientInfo(data);
    } catch (err) {
      toast.error("Erro ao buscar cliente");
      console.error("Erro ao buscar cliente:", err);
    }
  };

  useEffect(() => {
    if (refNumber) {
      getClientInfo();
    }
  }, [refNumber]);

  const nomeCompleto = clientInfo?.NOME?.trim() ?? "";
  const palavras = nomeCompleto.split(" ").filter(Boolean);
  const nomeExibido =
    palavras.length >= 2 ? `${palavras[0]} ${palavras[1]}` : nomeCompleto;

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxShadow: "none",
        borderRadius: "15px",
        border: "1px solid #0A0C33",
        height: { xs: "200px", sm: "200px", md: "80vh" },
        width: {
          xs: "100%",
          sm: "100%",
          md: "35%",
        },
        // minHeight: {
        //   xs: "250px",
        //   sm: "250px",
        //   md: "844px",
        // },
        // height: {
        //   md: "100%",
        // },
        marginBottom: {
          xs: "16px",
          sm: "16px",
          md: "74px",
        },
        p: 3,
        pb: "29px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          flex: 1,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "250px",
            height: "auto",
            background: "#F6F6F6",
            boxShadow: "0px 3px 6px #00000029",
            borderRadius: "12px",
            opacity: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              left: 0,
              top: 0,
              width: "16px",
              height: "100%",
              backgroundColor: "#326AFD",
              borderTopLeftRadius: "12px",
              borderBottomLeftRadius: "12px",
            }}
          />
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#0A0C33", mb: 0 }}
          >
            {nomeExibido}
          </Typography>
          <Box
            sx={{
              position: "absolute",
              right: 0,
              top: 0,
              width: "16px",
              height: "100%",
              backgroundColor: "#326AFD",
              borderTopRightRadius: "12px",
              borderBottomRightRadius: "12px",
            }}
          />
        </Box>
        <Box sx={{ width: "100%", textAlign: "center", marginTop: "36px" }}>
          <Typography
            variant="h6"
            sx={{ color: "#0A0C33", fontWeight: "bold" }}
          >
            REF: {refNumber}
          </Typography>
          <Typography
            variant="h6"
            sx={{ color: "#0A0C33", fontWeight: "bold" }}
          >
            Processo nº {processNumber}
          </Typography>
          {!isMobile && (
            <Box sx={{ mt: 5 }}>
              <Typography variant="h6" sx={{ color: "#0A0C33" }}>
                CNPJ {clientInfo?.INSC_CNPJ}
              </Typography>
              <Typography variant="h6" sx={{ color: "#0A0C33" }}>
                {clientInfo?.ENDERECO}
              </Typography>
              <Typography variant="h6" sx={{ color: "#0A0C33" }}>
                {clientInfo?.CEP}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Card>
  );
};

export default ClientCard;
